<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>仓储结算</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        ref="searchFrom"
        class="demo-form-inline"
        label-width="100px"
        size="mini"
      >
        <div class="inpBox">
          <el-form-item label="结算单号:" prop="billNumber">
            <el-input
              placeholder=""
              maxlength="100"
              v-model="searchFrom.billNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户名称:" prop="customerName">
            <el-input
              placeholder=""
              maxlength="100"
              v-model="searchFrom.customerName"
            ></el-input>
          </el-form-item>
          <el-form-item label="账单状态:" prop="ccbillState">
            <el-select v-model="searchFrom.ccbillState" placeholder="请选择">
              <el-option
                v-for="(item, index) in ccbillStateOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票状态:" prop="invoiceState">
            <el-select v-model="searchFrom.invoiceState" placeholder="请选择">
              <el-option
                v-for="(item, index) in invoiceStateOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button
              type="primary"
              @click="searchClick"
              btnCode="000P00RB001"
              v-if="btnFlg[0]"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="resetClick"
              btnCode="000P00RB002"
              v-if="btnFlg[1]"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="addBtnClick"
              btnCode="000P00RB003"
              v-if="btnFlg[2]"
              >新增</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="changeBtnClick"
              btnCode="000P00RB004"
              v-if="btnFlg[3]"
              >修改</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="delClick"
              btnCode="000P00RB005"
              v-if="btnFlg[4]"
              >删除</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="wanChengClick"
              btncode="000P00RB006"
              v-if="btnFlg[5]"
              >完成</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="kaiPiaoOk"
              btncode="000P00RB007"
              v-if="btnFlg[6]"
              >开票完成</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="daochu"
              btncode="000P00RB008"
              v-if="btnFlg[7]"
              :disabled='isDisable'
              >导出</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="91%"
        style="width: 100%; margin-top: 10px"
        center
        @row-click="dianjixuanzhong"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <el-table-column
          type="index"
          prop="date"
          width="55"
          label="序号"
          align="center"
        ></el-table-column>
        <el-table-column prop="billNumber" label="结算单号" align="center">
          <template slot-scope="scope"><div>
            <el-button
              type="text"
              size="mini"
              @click="billNumberClick(scope.row)"
              >{{ scope.row.billNumber }}</el-button
            >
          </div></template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="totalSum"
          label="费用合计"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="ext1"
          label="账单状态"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="ext3"
          label="结算方式"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="text"
          label="结算范围"
          align="center"
        ></el-table-column>
        <el-table-column prop="invoiceState" label="开票状态" align="center">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.invoiceState == '2'">已开票</span>
            <span v-else-if="scope.row.invoiceState == '1'">未开票</span>
          </div></template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          :formatter="dateFormat"
        ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNum"
        :page-sizes="[1, 10, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 点击新增-->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addMark"
      @close="closeDialog('addFrom')"
      width="900px"
      center
    >
      <span>
        <el-form
          :model="addFrom"
          ref="addFrom"
          :rules="rules"
          :validate-on-rule-change="false"
          class="demo-form-inline"
          label-width="140px"
          size="mini"
        >
          <div class="addinpBox">
            <el-form-item
              label="客户名称"
              prop="customerName"
              style="margin-top: 20px"
            >
              <el-select
                v-model="addFrom.customerName"
                :validate-event="false"
                filterable
                clearable
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option
                  v-for="(item, index) in customerNameOptions"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item  label="费用费目"
            prop='cost'
            style="margin-top:20px;">
            :checked="checkedMore.includes(index)"
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                  <el-checkbox-group v-model="addFrom.cost" :validate-event = "false" >
                  <el-checkbox  v-for="(item,index) in checkData"
                    :key="index"
                    :label="item.id"
                    :validate-event = "false"
                    >
                    {{item.feeName}}
                  </el-checkbox>
                </el-checkbox-group>
          </el-form-item> -->
            <el-form-item label="费用费目" prop="cost" style="margin-top: 20px">
              <!-- <el-checkbox v-model="checkAll" @change="handleCheckAllChange" >全选</el-checkbox> -->
              <el-checkbox
                v-model="addFrom.cost"
                v-for="(item, index) in checkData"
                :key="index"
                :label="item.id"
                :validate-event="false"
                @change="handleCheckedCitiesChange"
                >{{ item.feeName }}</el-checkbox
              >
            </el-form-item>
            <el-form-item
              label="结算方式"
              prop="settlementType"
              style="margin-top: 20px"
            >
              <el-select
                v-model="addFrom.settlementType"
                :validate-event="false"
                @change="seleChange"
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option
                  v-for="(item, index) in settlementTypeOptions"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="结算月份"
              v-if="
                addFrom.settlementType == '1' || addFrom.settlementType == '3'
              "
              prop="settlementMonth"
              style="margin-top: 20px"
            >
              <el-date-picker
                :validate-event="false"
                v-model="addFrom.settlementMonth"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="合约号:"
              prop="contractNum"
              v-if="addFrom.settlementType == '2'"
              style="margin-top: 20px"
            >
              <el-input
                placeholder=""
                maxlength=""
                v-model="addFrom.contractNum"
                :validate-event="false"
                style="width: 240px"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="出库单号:"
              prop="outstockNo"
              v-if="addFrom.settlementType == '4'"
              style="margin-top: 20px"
            >
              <el-input
              @change="changeInput"
                placeholder=""
                maxlength=""
                v-model="addFrom.outstockNo"
                :validate-event="false"
                style="width: 240px"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="addSubmit('addFrom')"
          :loading="addLoading"
          >保存</el-button
        >
        <el-button @click="addSpuClose('addFrom')" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 点击修改-->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="changeMark"
      @close="reset('changeFrom')"
      width="900px"
      center
    >
      <span>
        <el-form
          :model="changeFrom"
          ref="changeFrom"
          :rules="rules"
          :validate-on-rule-change="false"
          class="demo-form-inline"
          label-width="140px"
          size="mini"
        >
          <div class="addinpBox">
            <el-form-item
              label="客户名称"
              prop="customerName"
              style="margin-top: 20px"
            >
              <el-select
                v-model="changeFrom.customerName"
                :disabled="keHuNameDisabled"
                :validate-event="false"
                filterable
                clearable
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option
                  v-for="(item, index) in customerNameOptions"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用费目" prop="cost" style="margin-top: 20px">
              <el-checkbox
                v-model="changeFrom.cost"
                v-for="(item, index) in checkData"
                :key="index"
                :label="item.id"
                :validate-event="false"
                >{{ item.feeName }}</el-checkbox
              >
            </el-form-item>
            <el-form-item
              label="结算方式"
              prop="settlementType"
              style="margin-top: 20px"
            >
              <el-select
                v-model="changeFrom.settlementType"
                :validate-event="false"
                @change="seleChange"
                placeholder="请选择"
                style="width: 240px"
              >
                <el-option
                  v-for="(item, index) in settlementTypeOptions"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="结算月份"
              v-if="
                changeFrom.settlementType == '1' ||
                changeFrom.settlementType == '3'
              "
              prop="settlementMonth"
              style="margin-top: 20px"
            >
              <el-date-picker
                :validate-event="false"
                v-model="changeFrom.settlementMonth"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="合约号:"
              prop="contractNum"
              v-if="changeFrom.settlementType == '2'"
              style="margin-top: 20px"
            >
              <el-input
                placeholder=""
                maxlength=""
                v-model="changeFrom.contractNum"
                :validate-event="false"
                style="width: 240px"
              ></el-input>
            </el-form-item>
              <el-form-item
              label="出库单号:"
              prop="outstockNo"
              v-if="changeFrom.settlementType == '4'"
              style="margin-top: 20px"
            >
              <el-input
               @change="changeInput1"
                placeholder=""
                maxlength=""
                v-model="changeFrom.outstockNo"
                :validate-event="false"
                style="width: 240px"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="changeSubmit('changeFrom')"
          :loading="changeLoading"
          >修改</el-button
        >
        <el-button @click="changeSpuClose('changeFrom')" size="mini"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  settlementBillAdd, // 新增
  settlementBillList, // 列表
  listBySysModel, // 新增-费目多选框数据
  seeGroupType, // 获取字典表下拉框数据
  settlementBillDelete, // 删除
  updateInvoiceStatusComplete, // 开票完成
  updateStatusComplete // 完成
} from '@/api/platform-settlement'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
import axios from 'axios'
import store from '@/store'
import { exportExcel } from '@/utils/fileDown.js'

export default {
  data () {
    return {
      isDisable: false,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '000P00RB001',
        '000P00RB002',
        '000P00RB003',
        '000P00RB004',
        '000P00RB005',
        '000P00RB006',
        '000P00RB007',
        '000P00RB008'
      ],
      feeId: '',
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        sysModel: '2',
        pageNo: 1,
        pageSize: 10
      },
      // 开票状态
      invoiceStateOptions: [
        {
          value: '1',
          label: '未开票'
        },
        {
          value: '2',
          label: '已开票'
        }
      ],
      // 结算单状态
      ccbillStateOptions: [],
      value: '',
      tableList: [],
      tableHeardArr: [],
      attrName: '', // 表头信息
      // 新增
      customerNameOptions: [], // 客户名称
      addFrom: {
        cost: [], // 费用费目
        costStr: '',
        keHuName: '', // 客户的name值
        outstockNo: '', // 客户的name值
        customerName: '', // 客户名称
        settlementType: '', // 结算方式
        settlementMonth: [], // 结算月份
        contractNum: '' // 合约号
      },
      // 修改
      changeMark: false,
      changeFrom: {
        cost: [], // 费用费目
        costStr: '',
        outstockNo: '', // 客户的name值
        keHuName: '', // 客户的name值
        customerName: '', // 客户名称
        settlementType: '', // 结算方式
        settlementMonth: [], // 结算月份
        contractNum: '' // 合约号
      },
      keHuNameDisabled: false,
      checkAll: true,
      isIndeterminate: true,
      checkedFlg: true,
      checkData: [],
      checkDataStr: '',
      addLoading: false,
      settlementTypeOptions: [],
      monthShow: false, // 结算月份的显示隐藏
      contractNumShow: false, // 合约号显示隐藏
      rules: {
        customerName: [
          { required: true, message: '客户名称不能为空！', trigger: 'blur' }
        ],
        settlementType: [
          { required: true, message: '结算方式不能为空！', trigger: 'blur' }
        ],
        settlementMonth: [
          { required: true, message: '结算月份不能为空！', trigger: 'blur' }
        ],
        contractNum: [
          { required: true, message: '合约号不能为空！', trigger: 'blur' }
        ],
        outstockNo: [
          { required: true, message: '出库单号不能为空！', trigger: 'blur' }
        ],
        fieldName: [
          { required: true, message: '字段名称不能为空！', trigger: 'blur' }
        ],
        cost: [
          { required: true, message: '费用费目不能为空！', trigger: 'blur' }
        ]
      },
      fieldNameDisabled: false, // 字段名修改禁用
      bianMaOptions: [],
      dataTypeOptions: [],
      jiLiangDanWeiOptions: [],
      selectOptions: [],
      selectData: '',
      addBtnShow: false,
      changeBtnShow: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      addMark: false, // 新增弹框
      changeLoading: false,
      xuanzhongArr: [],
      delBtnShow: true,
      spuName: '',
      changeId: ''
    }
  },
  created () {
    this.getSeatchData(this.searchFrom)
    this.getDistoryData()
    // this.feeId = localStorage.getItem('feeId')
    // this.spuName = localStorage.getItem('spuName')
    this.btnFlg = getBtn(this.btnIdArr, '/smpSettlement/CCjiesuandan')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 150 + 'px'
  },
  methods: {
    // 点击开票完成
    kaiPiaoOk () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.ccbillState == '1') {
        this.$message.error('只能完成已付款状态的数据！')
      } else {
        if (this.xuanzhongArr.invoiceState == '2') {
          this.$message.error('该条数据已开票完成！')
        } else {
          this.$confirm('是否确定开票完成？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              updateInvoiceStatusComplete({
                id: this.xuanzhongArr.id // id
              })
                .then((res) => {
                  DonMessage.success('操作成功!')
                  this.getSeatchData(this.searchFrom)
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            })
            .catch((err) => {
            // DonMessage.error(err.message)
            })
        }
      }
    },
    // 点击导出
    daochu () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else {
        this.isDisable = true
        setTimeout(() => {
          this.isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        let a = this.xuanzhongArr.invoiceState
        if (a == 1) {
          a = '未开票'
        } else {
          a = '已开票'
        }
        let form = {
          id: this.xuanzhongArr.id,
          customerName: this.xuanzhongArr.customerName,
          ext1: this.xuanzhongArr.ext1,
          invoiceState: a
        }
        // fetch(
        exportExcel(
          this.global.smpName +
          '/tSettlementBill/exportList',
          form,
          '仓储结算单信息表'
        )
      }
    },
    changeInput () {
      this.$forceUpdate()
    },
    changeInput1 () {
      this.$forceUpdate()
    },
    reset (formName) {
      this.addFrom.keHuName = ''
      this.addFrom.customerName = ''
      this.addFrom.settlementType = ''
      this.addFrom.outstockNo = ''
      this.addFrom.contractNum = ''
      this.addFrom.settlementMonth = []
    },
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = row
      this.currentXQ = 1
      this.$refs.tableRef.toggleRowSelection(row)
    },
    // 获取字典表数据 - 结算单状态
    getDistoryData () {
      seeGroupType({
        groupNo: 'ccbill_state'
      })
        .then((res) => {
          this.ccbillStateOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 查询接口
    getSeatchData () {
      settlementBillList(this.searchFrom)
        .then((res) => {
          this.tableList = res.list
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    resetClick () {
      this.searchFrom = {
        sysModel: '2',
        pageNo: 1,
        pageSize: 10
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击修改按钮
    changeBtnClick (row) {
      // let selectData = this.$refs.tableRef.selection
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else if (this.xuanzhongArr.ccbillState > '2') {
        this.$message.error('只能修改待审核和已审核状态的数据！')
      } else {
        this.changeMark = true
        this.title = '修改结算单'
        this.addBtnShow = false
        this.changeBtnShow = true
        this.fieldNameDisabled = true
        this.keHuNameDisabled = true
        this.checkAll = false
        this.getListBySysModel()
        this.getCustomerNameData()
        this.getDistoryCcbillType()
        this.changeFrom.customerName = this.xuanzhongArr.customerCode
        this.changeFrom.costStr = this.xuanzhongArr.feeId
        this.changeFrom.cost = this.changeFrom.costStr.split(',').map(Number)
        this.changeFrom.settlementType = this.xuanzhongArr.ccbillType
        this.changeFrom.settlementMonth.push(
          this.xuanzhongArr.billSdateStr,
          this.xuanzhongArr.billEdateStr
        )
        if (this.changeFrom.settlementMonth.length > '2') {
          this.changeFrom.settlementMonth.splice(
            this.changeFrom.settlementMonth[2],
            this.changeFrom.settlementMonth.length - 2
          )
        }
        this.changeFrom.contractNum = this.xuanzhongArr.saleNubmer
        this.changeFrom.outstockNo = this.xuanzhongArr.text
        this.changeId = this.xuanzhongArr.id
      }
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击删除
    delClick () {
      // console.log(this.xuanzhongArr,'222')
      // eslint-disable-next-line no-unused-vars
      let selectData = this.$refs.tableRef.selection
      // console.log(selectData.length,'222')
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else if (this.xuanzhongArr.ccbillState > '2') {
        this.$message.error('只能删除待审核和已审核状态的数据！')
      } else {
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            settlementBillDelete({
              id: this.xuanzhongArr.id // id
            })
              .then((res) => {
                DonMessage.success('操作成功!')
                this.getSeatchData(this.searchFrom)
              })
              .catch((err) => {
                DonMessage.error(err.message)
              })
            // eslint-disable-next-line handle-callback-err
          })
          .catch((err) => {
            // DonMessage.error(err.message)
          })
      }
    },
    // 获取客户名称
    getCustomerNameData (url, options, excelName) {
      // console.log(store.getUser().access_token, '222222')
      // let token = getToken();
      // let token = window.sessionStorage.getItem("token");
      // let jsonObj = JSON.parse(token);
      return new Promise((resolve, reject) => {
        axios.defaults.headers['content-type'] =
          'application/json;charset=UTF-8'
        axios({
          method: 'post',
          url: '/crm-server/crm/scustomer/queryCusterDataByTenantCode', // 请求地址
          data: {}, // 参数
          // responseType: 'blob', // 表明返回服务器返回的数据类型
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: 'Bearer ' + store.getUser().access_token
          }
        }).then(
          (response) => {
            resolve(response.data)
            if (response.code == '0') {
              this.customerNameOptions = response.data
            }
          },
          (err) => {
            reject(err)
          }
        )
      })
    },
    // 获取费目多选框数据
    getListBySysModel () {
      listBySysModel({
        sysModel: '2'
      })
        .then((res) => {
          this.checkData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 全选
    // handleCheckAllChange (val) {
    //   if (this.checkAll == true) {
    //     this.checkData.forEach(item => {
    //       this.addFrom.cost.push(item.id)
    //       // console.log(this.addFrom.cost, '0000')
    //     })
    //   } else {
    //     this.addFrom.cost = []
    //   }
    // },
    // 新增-选中多选框
    handleCheckedCitiesChange (value) {
      if (this.addFrom.cost.length == this.checkData.length) {
        this.checkAll = true
        this.checkedFlg = true
        // console.log(this.addFrom.cost, '1111')
      } else {
        this.checkAll = false
        this.checkedFlg = false
        // console.log(this.addFrom.cost, '22222')
      }
    },
    // 点击新建按钮
    addBtnClick () {
      this.getListBySysModel() // 获取费用列表-仓储费-超期费-9过户费

      this.addFrom.cost = []// 清空费用列表
      this.addMark = true
      this.addBtnShow = true
      this.changeBtnShow = false
      this.fieldNameDisabled = false
      this.title = '新增结算单'
      this.getCustomerNameData()
      this.getDistoryCcbillType()
      // this.checkAll = true
      // this.handleCheckAllChange()
      this.handleCheckedCitiesChange()
    },
    // 结算方式下拉框改变时
    seleChange (val) {
      if (val == '1') {
        this.addFrom.contractNum = ''
      } else if (val == '2') {
        this.addFrom.settlementMonth = []
      }
    },
    // 获取结算方式数据
    getDistoryCcbillType () {
      seeGroupType({
        groupNo: 'ccbill_type'
      })
        .then((res) => {
          this.settlementTypeOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 点击新增确定
    addSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.addFrom.cost, '999')
          this.checkDataStr = [...new Set(this.addFrom.cost)].toString()
          // console.log([...new Set(this.addFrom.cost)], '111')
          // console.log(this.checkDataStr, '222')
          // this.checkDataStr = Array.from(new Set(this.changeFrom.cost)).filter(Boolean).toString()
          let startTime = ''
          let endTime = ''
          if (this.addFrom.settlementMonth != []) {
            startTime = this.addFrom.settlementMonth[0]
            endTime = this.addFrom.settlementMonth[1]
          } else {
            startTime = ''
            endTime = ''
          }
          // 同时获取客户下拉框的valu和lable值
          this.customerNameOptions.forEach((item, index) => {
            if (this.addFrom.customerName == item.itemNo) {
              this.addFrom.keHuName = item.showName
            }
          })
          // this.addFrom.outstockNo = ''
          if (this.addFrom.settlementType == '4') {
            this.addFrom.contractNum = ''
          } else {
            this.addFrom.outstockNo = ''
          }
          this.addLoading = true
          settlementBillAdd({
            sysModel: '2',
            customerName: this.addFrom.keHuName, // 客户名称
            customerCode: this.addFrom.customerName, // 客户code
            feeId: this.checkDataStr, // 费目id
            billSdate: startTime, // 开始时间
            billEdate: endTime, // 结束时间
            ccbillType: this.addFrom.settlementType, // 结算方式
            saleNubmer: this.addFrom.contractNum, // 合约号
            outstockNo: this.addFrom.outstockNo // 出库单号
          })
            .then((res) => {
              this.$message.success('添加成功！')
              this.addLoading = false
              this.getSeatchData(this.searchFrom)
              this.addMark = false
            })
            .catch((err) => {
              this.addLoading = false
              this.$message.error(err.message)
            })
        } else {
          return false
        }
      })
    },
    // 去除数组的空字符串
    trimSpace (array) {
      for (var i = 0; i < array.length; i++) {
        if (
          array[i] == '' ||
          array[i] == null ||
          typeof array[i] == 'undefined'
        ) {
          array.splice(i, 1)
          i = i - 1
        }
      }
      return array
    },
    // 修改确定
    changeSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkDataStr = Array.from(new Set(this.changeFrom.cost))
            .filter(Boolean)
            .toString()
          // this.checkDataStr = this.changeFrom.cost.filter(Boolean).toString()
          console.log(this.checkDataStr, '/////')
          let startTime = ''
          let endTime = ''
          if (this.changeFrom.settlementMonth != []) {
            startTime = this.changeFrom.settlementMonth[0]
            endTime = this.changeFrom.settlementMonth[1]
          } else {
            startTime = ''
            endTime = ''
          }
          // 同时获取客户下拉框的valu和lable值
          this.customerNameOptions.forEach((item, index) => {
            if (this.changeFrom.customerName == item.itemNo) {
              this.changeFrom.keHuName = item.showName
            }
          })
          this.changeLoading = true
          settlementBillAdd({
            sysModel: '2',
            id: this.changeId,
            customerName: this.changeFrom.keHuName, // 客户名称
            customerCode: this.changeFrom.customerName, // 客户code
            feeId: this.checkDataStr, // 费目id
            billSdate: startTime, // 开始时间
            billEdate: endTime, // 结束时间
            ccbillType: this.changeFrom.settlementType, // 结算方式
            saleNubmer: this.changeFrom.contractNum, // 合约号
            outstockNo: this.changeFrom.outstockNo // 出库
          })
            .then((res) => {
              this.$message.success('修改成功！')
              this.changeLoading = false
              this.getSeatchData(this.searchFrom)
              this.changeMark = false
            })
            .catch((err) => {
              this.changeLoading = false
              this.$message.error(err.message)
            })
        } else {
          return false
        }
      })
    },
    // 取消
    addSpuClose (formName) {
      this.addMark = false
      this.$refs[formName].resetFields()
      // this.addFrom.keHuName = ''
      // this.addFrom.customerName = ''
      // this.addFrom.settlementType = ''
      // this.addFrom.contractNum = ''
      // this.addFrom.settlementMonth = []
      // this.addFrom.cost = []
      // this.$forceUpdate() // 强制刷新
    },
    closeDialog (formName) {
      this.$refs[formName].resetFields()
    },
    // 修改取消
    changeSpuClose (formName) {
      this.changeMark = false
      // this.$refs[formName].resetFields()
      this.changeFrom.keHuName = ''
      this.changeFrom.customerName = ''
      this.changeFrom.settlementType = ''
      this.changeFrom.contractNum = ''
      this.changeFrom.outstockNo = ''
      this.changeFrom.settlementMonth = []
    },
    // 点击完成按钮
    wanChengClick () {
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else {
        updateStatusComplete({
          id: this.xuanzhongArr.id
        })
          .then((res) => {
            this.$message.success('操作成功')
            this.getSeatchData(this.searchFrom)
          })
          .catch((err) => {
            this.$message.error(err.message)
          })
      }
    },
    // 跳转详情
    billNumberClick (row) {
      localStorage.setItem('cangChuId', row.id)
      this.$router.push('/smpSettlement/settlementDetails')
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
.searchBox {
  margin-left: 10px;
}
.inpBox {
  margin: 10px 0 0 -30px;
}

/deep/ .inpBox .el-range-editor--mini .el-input__inner {
  width: 150px;
}
.searchBtnBox {
  margin-top: 10px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 240px;
  // background-color:#fff;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
